<template>
  <v-sheet
    v-if="
      formOpen &&
        userData.role != undefined &&
        (formData.hasOwnProperty('id') || selectedData.new)
    "
    class="mt-2"
  >
    <v-tabs
      v-model="activeTab"
      color="grey lighten-1"
      dark
      slider-color="black"
    >
      <v-tab ripple>Details</v-tab>
      <v-tab v-if="userData.role.includes('Admin')" ripple>Stats</v-tab>
      <v-spacer />
      <input style="opacity: 0" type="text" id="clipboardTextIB" />
      <v-btn
        v-if="
          activeTab != 3 &&
            userData.role.includes('Admin') &&
            formData.businessSuppliersInformation_id == ''
        "
        :loading="createSupplierLoading"
        color="info"
        @click="createSupplier"
        >Create Supplier</v-btn
      >

      <v-btn
        color="#58595b"
        @click="$router.push(`/EntityLink/${formData.businessLinkKey}`)"
        >Go To Leads Link</v-btn
      >
      <v-btn
        v-if="formData.goodCauseLinkKey != ''"
        color="#68c6b3"
        @click="$router.push(`/ProspectingBuyers/${formData.goodCauseLinkKey}`)"
        >Go To G.C Link
      </v-btn>

      <div
        v-if="
          activeTab != 3 &&
            userData.role.includes('Admin') &&
            formData.businessSuppliersInformation_id != '' &&
            formData.id
        "
        class="mt-3"
        style="
          background-color: white;
          height: 30px;
          width: 30px;
          top: -7px;
          position: relative;
        "
      >
        <v-icon style="left: 3px; position: relative; top: 1px" color="#4cc7e8"
          >mdi-van-utility</v-icon
        >
      </div>

      <div
        v-if="
          activeTab != 3 &&
            userData.role.includes('Admin') &&
            formData.impactIsGC
        "
        class="mt-3"
        style="
          background-color: white;
          height: 30px;
          width: 30px;
          top: -7px;
          position: relative;
        "
      >
        <v-icon style="left: 3px; position: relative; top: 3px" color="#68c6b3"
          >mdi-charity</v-icon
        >
      </div>
      <span
        v-if="$route.name != 'ImpactBusinessAdminProfile'"
        style="color: white"
        class="pt-2 mt-1"
        >Only saves Impact Buyer details</span
      >
      <v-btn :loading="saving" color="success" @click="save">Save</v-btn>
      <!-- TAB : DETAILS -->
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-form ref="impactBusinessForm">
              <v-layout key="form" wrap justify-center>
                <v-flex xs12 class="pa-2" style="background: #fffee0">
                  <span class="subheading">Essential Details</span>
                </v-flex>
                <v-flex style="background: #fffee0" class="px-2" xs3>
                  <v-text-field
                    label="Entity Name"
                    v-model="formData.name"
                    :rules="[(v) => !!v || 'Company Name is required']"
                  />
                </v-flex>
                <v-flex style="background: #fffee0" class="px-2" xs3>
                  <v-autocomplete
                    label="Impact Buyer Type"
                    v-model="formData.impactBuyerType"
                    :items="buyerTypeList"
                  />
                </v-flex>
                <v-flex
                  style="background: #fffee0"
                  class="px-2"
                  xs3
                  v-if="userData.role.includes('Admin')"
                >
                  <v-select
                    v-model="formData.impactInterestedStatus"
                    :items="['Prospecting', 'Open', 'Not Interested']"
                    label="Interested Status"
                    placeholder="Please select"
                  />
                </v-flex>
                <v-flex
                  style="background: #fffee0"
                  class="px-2"
                  xs3
                  v-if="userData.role.includes('Admin')"
                >
                  <v-select
                    v-model="formData.status"
                    :items="['Data Only', 'Drafting', 'Live Report']"
                    label="Visibility Status"
                    placeholder="Please select"
                  />
                </v-flex>
                <v-flex style="background: #fffee0" class="px-2" xs3>
                  <v-autocomplete
                    v-model="formData.goodCause_id"
                    :items="goodCauses"
                    item-text="name"
                    item-value="id"
                    label="Chosen Good Cause / Area of Impact"
                    placeholder="Please select"
                  />
                </v-flex>
                <v-flex style="background: #fffee0" class="px-2" xs3>
                  <v-text-field
                    v-model="formData.impactLeadConnectionName"
                    label="Name of Contact (Lead)"
                  ></v-text-field>
                </v-flex>
                <v-flex style="background: #fffee0" class="px-2" xs3>
                  <v-text-field
                    v-model="formData.impactLeadConnectionTitle"
                    label="Their Title"
                  ></v-text-field>
                </v-flex>
                <v-flex style="background: #fffee0" class="px-2" xs3>
                  <v-text-field
                    v-model="formData.impactGoodcauseConnectionRelation"
                    label="The Connection"
                  ></v-text-field>
                </v-flex>
                <v-flex style="background: #fffee0" class="px-2 mb-2" xs3>
                  <v-text-field
                    v-model="formData.impactEmail"
                    :rules="[(v) => !!v || 'Email is required']"
                    hide-details
                    label="Email of Contact (Lead) - (Not Public)"
                    required
                  />
                </v-flex>
                <v-flex style="background: #fffee0" class="px-2 mb-2" xs3>
                  <v-text-field
                    v-model="formData.impactPhone"
                    hide-details
                    label="Phone of Contact (Lead) = (Not Public)"
                  />
                </v-flex>
                <v-flex style="background: #fffee0" class="px-2 mb-2" xs3>
                  <v-select
                    label="Chance of Engagement"
                    v-model="formData.impactChanceOfLead"
                    :items="['Low', 'Good', 'Strong']"
                  >
                  </v-select>
                </v-flex>
                <v-flex style="background: #fffee0" class="px-2 mb-2" xs3>
                  <v-text-field
                    v-model="formData.businessLinkKey"
                    label="Leads Link"
                    @click:append="
                      copyField(
                        'https://upstreamnz.co.nz/EntityLink/' +
                          formData.businessLinkKey
                      )
                    "
                    append-icon="mdi-content-copy"
                    readonly
                  />
                </v-flex>

                <v-flex style="background: #d2eee8" xs5 class="px-2 my-2 mb-4">
                  <v-textarea
                    label="Action Notes"
                    v-model="formData.impactActionNotes"
                    rows="10"
                  >
                  </v-textarea>
                </v-flex>
                <v-flex xs1></v-flex>
                <v-flex style="background: #d2eee8" xs6 class="px-2 my-2 mb-4">
                  <v-layout row wrap>
                    <v-flex xs8 class="px-2">
                      <v-text-field
                        v-model="formData.goodCauseLinkKey"
                        label="Good Cause Link"
                        @click:append="
                          copyField(
                            'https://upstreamnz.co.nz/ProspectingBuyers/' +
                              formData.goodCauseLinkKey
                          )
                        "
                        readonly
                        hide-details
                        append-icon="mdi-content-copy"
                      />
                    </v-flex>
                    <v-flex xs4 class="px-2">
                      <v-select
                        :items="[
                          'Haven\'t Done',
                          'In Process',
                          'Completed',
                          'Other',
                        ]"
                        label="G.C Progress Status "
                        v-model="formData.goodCauseAction"
                        readonly
                        hide-details
                      >
                      </v-select>
                    </v-flex>
                    <v-flex class="px-2 mb-2" xs8>
                      <v-checkbox
                        label="G.C Link page (Select this option to include in Prospecting
        help)"
                        v-model="formData.goodCauseLinkEnabled"
                      ></v-checkbox>
                    </v-flex>

                    <!-- G.C Link Page ( Checkbox ) -->
                    <v-flex class="px-2 mb-2" xs3>
                      <v-checkbox
                        label="Is a Good Cause?"
                        v-model="formData.impactIsGC"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        label="Charity Comments"
                        v-model="formData.goodCauseComments"
                        rows="7"
                        readonly
                      >
                      </v-textarea>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <span class="subheading">Impact Buyer Stats (From)</span>
                </v-flex>

                <v-flex xs4 style="text-align: center; font-weight: bold">
                  <span style="font-size: 18pt; color: #58595b"
                    >Total Enq:
                    <span style="color: #325181">
                      {{ formData.enquiryTotal }}
                    </span>
                    <p
                      style="cursor: pointer"
                      @click="
                        $router.push(
                          `/admin/salesEnquiry/${formData.impactLatestSalesEnquiry_id}`
                        )
                      "
                    >
                      <span style="color: red"
                        >Click here to go to latest Enquiry (*May take 5
                        secs)</span
                      >
                    </p>
                  </span>
                </v-flex>
                <v-flex xs4 style="text-align: center; font-weight: bold">
                  <span style="font-size: 18pt; color: #58595b">
                    Total Rev:

                    <span style="color: #325181">{{
                      formatMoney(formData.revenueTotal)
                    }}</span>
                  </span>
                </v-flex>
                <v-flex xs4 style="text-align: center; font-weight: bold">
                  <span style="font-size: 18pt; color: #58595b">
                    Total $UC:
                    <span style="color: #325181">{{
                      formatMoney(formData.cCTotal)
                    }}</span>
                  </span>
                </v-flex>

                <!-- <v-flex xs12 class="mt-4">
                  <span class="subheading">Lead Stats (From)</span>
                </v-flex>
                <v-flex xs4 style="text-align: center; font-weight: bold">
                  <span style="font-size: 18pt; color: #58595b"
                    >Total Active Lead Cards:
                    <span style="color: #325181">
                      {{ formData.leadsCount }}
                    </span>
                  </span>
                </v-flex> -->
                <!-- <v-flex xs4 style="text-align: center; font-weight: bold">
                  <span style="font-size: 18pt; color: #58595b">
                    Future Followup Leads:
                    <span style="color: #325181">{{
                      formatMoney(formData.cCTotal)
                    }}</span>
                  </span>
                </v-flex>
                <v-flex xs4 style="text-align: center; font-weight: bold">
                  <span style="font-size: 18pt; color: #58595b">
                    Attempted Leads:

                    <span style="color: #325181">{{
                      formatMoney(formData.revenueTotal)
                    }}</span>
                  </span>
                </v-flex> -->

                <v-flex xs12 class="px-2">
                  <v-textarea
                    label="Admin Notes"
                    v-model="formData.impactAdminNotes"
                    rows="10"
                  >
                  </v-textarea>
                </v-flex>
                <v-flex xs12 class="pa-2 mb-2">
                  <span class="subheading"
                    >Detailed Information for Live Report</span
                  >
                </v-flex>
                <v-flex xs6 class="autoMargin px-2">
                  <span class="subheading">Profile Picture</span>
                  <template v-if="formData.id">
                    <div v-if="formData.imageUrl">
                      <v-img
                        :src="formData.imageUrl"
                        :width="300"
                        :height="200"
                        class="autoMargin"
                      />
                      <v-btn
                        small
                        block
                        color="info"
                        @click="changeImage = true"
                        >Change Image</v-btn
                      >
                    </div>
                    <croppa
                      v-if="!formData.imageUrl || changeImage"
                      v-model="image"
                      :show-loading="true"
                      :width="300"
                      :height="200"
                      :quality="2"
                      canvas-color="#FFF"
                      placeholder-color="#000000"
                      placeholder="Choose profile image"
                      style="width: 300px"
                      initial-size="contain"
                    />
                    <div
                      v-if="!formData.imageUrl || changeImage"
                      class="caption text-xs-center"
                    >
                      Use scroll wheel to zoom in / out and drag to reposition.
                    </div>
                  </template>
                  <template v-else>
                    <br />Please save Impact Buyer before adding a photo
                  </template>
                </v-flex>
                <v-flex class="px-2" xs6>
                  <v-textarea
                    v-model="formData.whoWeAre"
                    label="Who we are"
                    counter="700"
                    maxlength="700"
                    rows="12"
                    :rules="[
                      (v) =>
                        v.length <= 700 || 'Maximum of 700 characters allowed.',
                    ]"
                  />
                </v-flex>
                <v-flex class="px-2" xs6>
                  <v-text-field
                    v-model="formData.website"
                    hide-details
                    label="Website"
                  />
                </v-flex>
                <v-flex class="px-2" xs6>
                  <v-text-field
                    v-model="formData.description"
                    hint="For Example: A construction company in Canterbury"
                    label="Description with location"
                  ></v-text-field>
                </v-flex>

                <v-flex class="px-2" xs6 v-if="userData.role.includes('Admin')">
                  <v-text-field
                    v-model="formData.urlKeyword"
                    hint="https://upstreamnz.co.nz/ImpactBuyer/YOUR_KEYWORD"
                    label="URL Keyword ~ /ImpactBuyer/keyword"
                  />
                </v-flex>

                <v-flex class="px-2" xs6 v-if="userData.role.includes('Admin')">
                  <v-text-field
                    v-model="formData.impactAddress"
                    hide-details
                    label="Address (Not Public)"
                  />
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  v-if="userData.role.includes('Admin')"
                >
                  <v-textarea
                    v-model="formData.recentImpactStory"
                    label="Most Recent Impact Story (Connected to Area of Impact)"
                    counter="700"
                    maxlength="700"
                    readonly
                    :rules="[
                      (v) =>
                        v.length <= 400 || 'Maximum of 700 characters allowed.',
                    ]"
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item v-if="userData.role.includes('Admin')">
        <v-card flat>
          <v-card-text>
            <v-form ref="impactBusinessForm">
              <v-layout key="form" wrap justify-center>
                <v-flex v-if="userData.role.includes('Admin')" xs12>
                  <strong>Front page Stats Settings</strong>
                </v-flex>
                <v-flex v-if="userData.role.includes('Admin')" xs12>
                  <v-checkbox
                    v-model="formData.buyerSelected"
                    label="Is a Buyer"
                  />
                </v-flex>
                <!-- Buyer Section -->
                <v-flex
                  v-if="
                    userData.role.includes('Admin') && formData.buyerSelected
                  "
                  xs6
                >
                  <v-text-field
                    v-model="formData.suppliersUsed"
                    hide-details
                    label="Number of Suppliers used"
                    required
                  />
                </v-flex>
                <v-flex
                  v-if="
                    userData.role.includes('Admin') && formData.buyerSelected
                  "
                >
                  <v-text-field
                    v-model="formData.buyersSlogan"
                    hide-details
                    label="Message for Stat 1"
                    counter="110"
                    maxlength="110"
                    :rules="[
                      (v) =>
                        v.length <= 100 || 'Maximum of 110 characters allowed.',
                    ]"
                    required
                  />
                </v-flex>
                <v-flex
                  v-if="
                    userData.role.includes('Admin') && formData.buyerSelected
                  "
                  xs6
                >
                  <v-text-field
                    v-model="formData.cCTotal"
                    hide-details
                    label="Contributions We have Generated"
                    readonly
                  />
                </v-flex>
                <v-flex
                  v-if="
                    userData.role.includes('Admin') && formData.buyerSelected
                  "
                >
                  <v-text-field
                    v-model="formData.contributionsGeneratedSlogan"
                    hide-details
                    label="Message for Stat 2"
                    counter="110"
                    maxlength="110"
                    :rules="[
                      (v) =>
                        v.length <= 100 || 'Maximum of 110 characters allowed.',
                    ]"
                    required
                  />
                </v-flex>
                <v-flex
                  xs12
                  v-if="
                    userData.role.includes('Admin') && formData.buyerSelected
                  "
                >
                  <v-textarea
                    v-model="formData.communityHoursSlogan"
                    hide-details
                    label="Slogan for Community Hours Stat"
                    counter="100"
                    maxlength="100"
                    :rules="[
                      (v) =>
                        v.length <= 100 || 'Maximum of 100 characters allowed.',
                    ]"
                    required
                  />
                </v-flex>
                <!-- Buyer Section End -->
                <!-- Tradies Section -->
                <v-flex v-if="userData.role.includes('Admin')" xs12>
                  <v-checkbox
                    v-model="formData.tradiesSelected"
                    label="Tradies information"
                  />
                </v-flex>
                <v-flex
                  xs12
                  v-if="
                    formData.tradiesSelected && userData.role.includes('Admin')
                  "
                >
                  <v-textarea
                    v-model="formData.tradieSlogan"
                    hide-details
                    label="Slogan under Badge"
                    counter="100"
                    maxlength="100"
                    :rules="[
                      (v) =>
                        v.length <= 100 || 'Maximum of 100 characters allowed.',
                    ]"
                    required
                  />
                </v-flex>
                <v-flex
                  xs6
                  v-if="
                    formData.tradiesSelected && userData.role.includes('Admin')
                  "
                >
                  <v-text-field
                    v-model="formData.tradieStat1"
                    hide-details
                    label="First Stat"
                    counter="55"
                    maxlength="55"
                    :rules="[
                      (v) =>
                        v.length <= 55 || 'Maximum of 55 characters allowed.',
                    ]"
                    required
                  />
                </v-flex>
                <v-flex
                  xs6
                  v-if="
                    formData.tradiesSelected && userData.role.includes('Admin')
                  "
                >
                  <v-text-field
                    v-model="formData.tradieMessage1"
                    hide-details
                    label="Message for Stat 1"
                    counter="110"
                    maxlength="110"
                    :rules="[
                      (v) =>
                        v.length <= 100 || 'Maximum of 110 characters allowed.',
                    ]"
                    required
                  />
                </v-flex>
                <v-flex
                  xs6
                  v-if="
                    formData.tradiesSelected && userData.role.includes('Admin')
                  "
                >
                  <v-text-field
                    v-model="formData.tradieStat2"
                    hide-details
                    label="Second Stat"
                    counter="55"
                    maxlength="55"
                    :rules="[
                      (v) =>
                        v.length <= 55 || 'Maximum of 55 characters allowed.',
                    ]"
                    required
                  />
                </v-flex>
                <v-flex
                  xs6
                  v-if="
                    formData.tradiesSelected && userData.role.includes('Admin')
                  "
                >
                  <v-text-field
                    v-model="formData.tradieMessage2"
                    hide-details
                    label="Message for Stat 2"
                    counter="110"
                    maxlength="110"
                    :rules="[
                      (v) =>
                        v.length <= 110 || 'Maximum of 110 characters allowed.',
                    ]"
                    required
                  />
                </v-flex>

                <!-- Tradies Section End -->
                <!-- Suppliers Section -->
                <v-flex v-if="userData.role.includes('Admin')" xs12>
                  <v-checkbox
                    v-model="formData.supplierSelected"
                    label="Is a Supplier"
                  />
                </v-flex>
                <v-flex
                  v-if="
                    userData.role.includes('Admin') && formData.supplierSelected
                  "
                  xs6
                >
                  <v-text-field
                    v-model="formData.supplier_enquiryTotal"
                    hide-details
                    label="Impact Buyer Sales"
                    required
                  />
                </v-flex>
                <v-flex
                  v-if="
                    userData.role.includes('Admin') && formData.supplierSelected
                  "
                >
                  <v-text-field
                    v-model="formData.suppliersSlogan"
                    hide-details
                    label="Message for Stat 1"
                    counter="110"
                    maxlength="110"
                    :rules="[
                      (v) =>
                        v.length <= 100 || 'Maximum of 110 characters allowed.',
                    ]"
                    required
                  />
                </v-flex>
                <v-flex
                  v-if="
                    userData.role.includes('Admin') && formData.supplierSelected
                  "
                  xs6
                >
                  <v-text-field
                    v-model="formData.supplier_cCTotal"
                    hide-details
                    label="Contributions We have Generated"
                    required
                  />
                </v-flex>
                <v-flex
                  v-if="
                    userData.role.includes('Admin') && formData.supplierSelected
                  "
                >
                  <v-text-field
                    v-model="formData.contributionsGeneratedSloganSupplier"
                    hide-details
                    label="Message for Stat 2"
                    counter="110"
                    maxlength="110"
                    :rules="[
                      (v) =>
                        v.length <= 100 || 'Maximum of 110 characters allowed.',
                    ]"
                    required
                  />
                </v-flex>
                <v-flex
                  xs12
                  v-if="
                    userData.role.includes('Admin') && formData.supplierSelected
                  "
                >
                  <v-textarea
                    v-model="formData.communityHoursSloganSupplier"
                    hide-details
                    label="Slogan for Community Hours Stat"
                    counter="100"
                    maxlength="100"
                    :rules="[
                      (v) =>
                        v.length <= 100 || 'Maximum of 100 characters allowed.',
                    ]"
                    required
                  />
                </v-flex>
                <!-- Suppliers Section End -->
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
    <v-layout row class="pl-3 pr-3">
      <v-btn
        v-if="formData.status === 'Live Report'"
        @click="downloadCertificate"
        >Download Certificate</v-btn
      >
      <v-btn
        v-if="
          activeTab != 3 &&
            userData.role.includes('Admin') &&
            formData.businessSuppliersInformation_id == ''
        "
        :loading="createSupplierLoading"
        color="info"
        @click="createSupplier"
        >Create Supplier</v-btn
      >

      <v-btn
        v-if="activeTab != 3"
        :loading="saving"
        color="success"
        @click="save"
        >Save</v-btn
      >
      <p class="mt-2 pt-1">Created Date: {{ formData.created_at }}</p>
    </v-layout>
  </v-sheet>
  <v-sheet v-else>
    <div style="margin: auto; width: 50px; padding-top: calc(25% - 25px)">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
  </v-sheet>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["selectedData", "formOpen"],
  data: () => ({
    imageOrientation: "Landscape",
    impactStoryDialog: false,
    image: null,
    changeImage: false,
    activeTab: null,
    saving: false,

    // Create Supplier
    createSupplierLoading: false,

    // Buyer Type List
    buyerTypeList: [
      "Church",
      "Charity",
      "Social Enterprise",
      "School",
      "Pre-School",
      "Self Employed",
      "Small Service Business ( 2 - 20 )",
      "Medium Service Business ( 20 - 50 )",
      "Large Company ( 50 + )",
      "Physical Shop",
      "Online Store",
      "Farm",
      "Mall",
      "MP Office",
      "Small Corporate ( Based Regionally )",
      "Large Corporate ( Based Nationally )",
      "Local Government ( District Entity )",
      "Government ( National Entity )",
    ],

    formData: {},
  }),
  computed: {
    ...mapGetters({
      user: "user",
      userData: "user/userData",
      goodCauses: "goodCauses/listOrderedByCategories",
      currentProfile: "impactBusinesses/currentProfile",
    }),
  },
  watch: {
    selectedData: function() {
      if (this.selectedData.hasOwnProperty("id")) {
        this.loadImpactBusiness();
      } else if (this.selectedData.new) {
        this.formData = {
          status: "Data Only",
          impactInterestedStatus: "Prospecting",
        };
      }
    },
  },
  mounted() {
    if (this.selectedData.hasOwnProperty("id")) {
      this.loadImpactBusiness();
    } else if (this.selectedData.new) {
      this.formData = {
        status: "Data Only",
        impactInterestedStatus: "Prospecting",
      };
    }
  },
  methods: {
    loadImpactBusiness() {
      this.$store
        .dispatch("impactBusinesses/loadProfile", this.selectedData.id)
        .then(() => {
          this.formData = JSON.parse(JSON.stringify(this.currentProfile));
          this.formData.impactIsGC = parseInt(this.formData.impactIsGC);
          this.formData.goodCauseLinkEnabled = parseInt(
            this.formData.goodCauseLinkEnabled
          );
        });
    },
    save(addNew = false) {
      this.saving = true;
      if (this.image && this.image.imageSet) {
        this.formData.image = {
          dataUrl: this.image.generateDataUrl(),
        };
      } else {
        delete this.formData.image;
      }
      this.$store
        .dispatch("impactBusinesses/save", this.formData)
        .then((business) => {
          this.$store.dispatch("impactBusinesses/loadAllAdmin");
          this.formData = business;
          this.formData.impactIsGC = parseInt(this.formData.impactIsGC);
          this.formData.goodCauseLinkEnabled = parseInt(
            this.formData.goodCauseLinkEnabled
          );
          this.saving = false;
          this.$emit("saved");

          if (addNew == true) {
            this.formData = {
              status: "Data Only",
              impactInterestedStatus: "Prospecting",
            };
          } else if (this.$route.params.id == "new") {
            this.$router.push(`/admin/impactBusinessAdmin/${business.id}`);
          }
        });
    },
    createSupplier() {
      this.$swal
        .fire({
          icon: "warning",
          title:
            "Are you sure you want to create a Supplier Listing off this buyer",
          showDenyButton: true,
          showCancelButton: true,
          cancelButtonText: `Don't Create`,
          confirmButtonText: `Create`,
          confirmButtonColor: "green",
          cancelButtonColor: "red",
        })
        .then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.createSupplierLoading = true;
            let data = {
              business_id: this.formData.id,
            };
            this.$store
              .dispatch("impactBusinesses/createSupplier", data)
              .then((business) => {
                this.createSupplierLoading = false;
                this.$router.push(`/admin/businesses/${data.business_id}`);
              });
          }
        });
    },
    downloadCertificate() {
      window.open(
        `https://upstreamnz.live.simplesoftware.nz/impactBusiness/pdf/${this.formData.id}`,
        "_blank",
        "location=no"
      );
    },
    formatMoney(amount) {
      if (typeof amount != "undefined" && amount != "") {
        let formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
        });
        return formatter.format(parseInt(amount));
      } else {
        return "$0.00";
      }
    },
    copyField(data) {
      var copyText = document.querySelector("#clipboardTextIB");
      copyText.value = data;
      copyText.select();
      setTimeout(() => {
        document.execCommand("copy");
        Vue.notify({
          type: "info",
          duration: 2000,
          title: "Copied to Clipboard",
        });
      }, 100);
    },
  },
};
</script>

<style>
.croppa-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
}

.icon-remove {
  position: absolute;
  top: 5px !important;
  right: -35px !important;
}

.croppa-container canvas {
  border: 1px solid;
}
</style>
